/* Casa de Alix · 1.8 : pages légales (sommaire cliquable, liens vers les autres pages). */
(() => {
  if (!document.body.classList.contains('ca-tpl-policy')) return;
  const box = document.querySelector('.shopify-policy__container');
  const body = box && box.querySelector('.shopify-policy__body');
  if (!body) return;
  const slug = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48);
  const heads = [...body.querySelectorAll('h2')];
  if (heads.length > 1) {
    const toc = document.createElement('nav');
    toc.className = 'ca-pol__toc'; toc.setAttribute('aria-label', 'Sommaire');
    toc.innerHTML = '<p>Sommaire</p><ol></ol>';
    const ol = toc.querySelector('ol');
    heads.forEach((h, i) => {
      if (!h.id) h.id = slug(h.textContent) || 'partie-' + (i + 1);
      const li = document.createElement('li'); const a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); ol.appendChild(li);
    });
    box.insertBefore(toc, body);
    if ('IntersectionObserver' in window) {
      const links = new Map([...ol.querySelectorAll('a')].map((a) => [a.hash.slice(1), a]));
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        links.forEach((a) => a.removeAttribute('aria-current'));
        const a = links.get(e.target.id); if (a) a.setAttribute('aria-current', 'true');
      }), { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach((h) => io.observe(h));
    }
  } else {
    body.style.gridColumn = '1 / span 8'; box.classList.add('ca-pol--plain');
  }
  const pol = [...document.querySelectorAll('.ca-footer__pol a')].filter((a) => a.pathname !== location.pathname);
  if (pol.length) {
    const more = document.createElement('div'); more.className = 'ca-pol__more';
    more.innerHTML = '<p>Les autres pages</p><nav aria-label="Autres pages d’information"></nav>';
    pol.forEach((a) => { const c = document.createElement('a'); c.href = a.href; c.textContent = a.textContent; more.querySelector('nav').appendChild(c); });
    box.appendChild(more);
  }
})();

/* Casa de Alix · 2.4 : parallaxe douce sur [data-parallax="k"] (k = part du décalage, négatif = sens inverse). */
(() => {
  const els = [...document.querySelectorAll('[data-parallax]')];
  if (!els.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let queued = false;
  const run = () => {
    queued = false;
    const vh = window.innerHeight;
    els.forEach((el) => {
      const box = (el.closest('section, figure') || el.parentElement).getBoundingClientRect();
      if (box.bottom < -200 || box.top > vh + 200) return;
      const k = parseFloat(el.dataset.parallax) || 0;
      const offset = (box.top + box.height / 2) - vh / 2;
      el.style.transform = 'translate3d(0,' + (-offset * k).toFixed(1) + 'px,0)';
    });
  };
  const ask = () => { if (!queued) { queued = true; requestAnimationFrame(run); } };
  window.addEventListener('scroll', ask, { passive: true });
  window.addEventListener('resize', ask);
  run();
})();

/* 2.7 : accordéons (FAQ, fiche produit) qui s'ouvrent et se ferment en douceur */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const SEL = '.ca-faq__item > summary, .ca-pdp__details details > summary';
  const ease = 'cubic-bezier(.22, .61, .36, 1)';
  document.addEventListener('click', (e) => {
    const sum = e.target.closest(SEL);
    if (!sum || reduce.matches || !sum.parentElement.animate) return;
    const d = sum.parentElement;
    e.preventDefault();
    const start = d.getBoundingClientRect().height;
    if (d._anim) { d._anim.cancel(); d._anim = null; }
    const cs = getComputedStyle(d);
    const closed = sum.getBoundingClientRect().height + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth) + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    const opening = !d.open || d.classList.contains('is-closing');
    d.classList.remove('is-closing', 'is-opening');
    let end;
    if (opening) {
      d.open = true;
      d.classList.add('is-opening');
      end = d.scrollHeight + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
      requestAnimationFrame(() => requestAnimationFrame(() => d.classList.remove('is-opening')));
    } else {
      d.classList.add('is-closing');
      end = closed;
    }
    d.style.overflow = 'hidden';
    const a = d.animate({ height: [start + 'px', end + 'px'] }, { duration: opening ? 520 : 420, easing: ease });
    d._anim = a;
    a.onfinish = () => {
      if (!opening) { d.open = false; d.classList.remove('is-closing'); }
      d.style.overflow = '';
      d._anim = null;
    };
  });
})();

/* 2.8 : photos portées des cartes (invisibles jusqu'au survol) décodées d'avance,
   pour que le navigateur n'ait pas à les décoder pendant le premier fondu. */
(() => {
  const ready = (img) => { if (img.decode) img.decode().catch(() => {}); };
  const prep = (scope) => scope.querySelectorAll('.ca-card .ca-worn').forEach((img) => {
    if (img._casaDecode) return;
    img._casaDecode = true;
    if (img.complete && img.naturalWidth) ready(img);
    else img.addEventListener('load', () => ready(img), { once: true });
  });
  prep(document);
  document.addEventListener('shopify:section:load', (e) => prep(e.target));
})();
